import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Breadcrumbs } from "../../../../eva-components/Breadcrumbs";
import { Logo } from "../../../../eva-components/Logo";
import styles from "./FooterBreadcrumbs.module.scss";
export const FooterBreadcrumbs = ({ list, logoProps }) => {
    if (!list.length)
        return null;
    const [root] = list;
    return (_jsxs("div", { className: styles.listContainer, children: [_jsx(Logo, { ...logoProps, className: styles.logo, link: root.url }), _jsx(Breadcrumbs, { list: list, isAutomaticallyExpanded: true, className: styles.breadcrumbs })] }));
};
//# sourceMappingURL=FooterBreadcrumbs.js.map